import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=956a1ac6&scoped=true"
import script from "./ChatFooter.vue?vue&type=script&lang=js"
export * from "./ChatFooter.vue?vue&type=script&lang=js"
import style0 from "./ChatFooter.vue?vue&type=style&index=0&id=956a1ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a1ac6",
  null
  
)

export default component.exports